import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import AuthContext from '../context/auth/authContext'

function AdminPrivateRoute({ component: Component, render, ...rest }) {
    const authContext = useContext(AuthContext)
    const { token } = authContext

    return (
        <Route
            {...rest}
            render={(props) =>
                localStorage.admintoken ? (
                    Component ? (
                        <Component {...props} />
                    ) : (
                        render(props)
                    ) // handles both
                ) : (
                    <Redirect to={{ pathname: '/', state: { referer: props.location } }} />
                )
            }
        />
    )
}

export default AdminPrivateRoute
